import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 bg-secondary-800 text-secondary-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className="ri-play-fill text-xl" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                国产在线观看
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-300">
              国产在线观看是专注于国产影视作品的在线观看信息平台，聚合高清国产电影、电视剧与综艺节目资源，
              持续更新热门内容，帮助用户快速发现、浏览并了解自己感兴趣的国产影视作品。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              <Link to="/category/电影" className="transition-colors hover:text-accent-400">
                影视分类
              </Link>
            </h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <Link to="/category/电影" className="text-secondary-300 transition-colors hover:text-accent-400">
                  国产电影
                </Link>
              </li>
              <li>
                <Link to="/category/电视剧" className="text-secondary-300 transition-colors hover:text-accent-400">
                  国产电视剧
                </Link>
              </li>
              <li>
                <Link to="/category/综艺" className="text-secondary-300 transition-colors hover:text-accent-400">
                  国产综艺
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              <Link to="/about" className="transition-colors hover:text-accent-400">
                关于我们
              </Link>
            </h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <Link to="/about" className="text-secondary-300 transition-colors hover:text-accent-400">
                  网站介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-secondary-300 transition-colors hover:text-accent-400">
                  联系方式
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-secondary-300 transition-colors hover:text-accent-400">
                  法律声明
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-700 pt-6 text-xs text-secondary-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 国产在线观看 · 本站所有影视资料均为虚拟示范数据，仅供演示使用。</p>
          <p>本站不提供真实视频播放、下载及付费服务。</p>
        </div>
      </div>
    </footer>
  );
}